import { render, staticRenderFns } from "./ConnectShortcutToUserDialog.vue?vue&type=template&id=6dc4337b"
import script from "./ConnectShortcutToUserDialog.vue?vue&type=script&lang=js"
export * from "./ConnectShortcutToUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports